<template>
    <div>
        <div class="section-heading">
            <h4>Platforms</h4>
            <!-- <p>Select your desired platforms</p> -->
            <p class="w-70 mt-3">Select the platforms you want to monitor and optimize with Weavr. Whether you're tracking marketplaces, quick commerce, or brand websites
                Customize your plan to focus on what matters most to your business.</p>
        </div>
        <div class="mt-4">
            <p class="font-weight-bold">Select your desired platforms.</p>
            <div class="d-flex w-50 flex-wrap">
                <button class="demo-btn" :class="{ 'active': platform.isSelected }" @click="selectPlatforms(platform)"
                    v-for="platform of totalPlatforms" :key="platform.platform_id">
                    {{ platform.platform_name }}
                </button>
                <button class="demo-btn" :class="{ 'active': checkOthers }"
                    @click="checkOthers = !checkOthers">Others</button>
            </div>
        </div>
        <div class="mt-4" v-if="checkOthers">
            <p class="font-weight-bold">Have other platform in mind?</p>
            <input type="text" class="d-block demo-input" v-model="productFeedback.platform_name"
                placeholder="Platform Name">
            <input type="text" class="d-block demo-input mt-3" v-model="productFeedback.platform_url"
                placeholder="Platform URL">
        </div>
        <div class="mt-4">
            <div class="d-flex">
                <button class="primarycolor mr-3" @click="saveSelectedPlatforms">Save and Next</button>
                <button class="navigationButton" @click="setSelectedSection(previousSection)">Back</button>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "Platforms",
    data() {
        return {
            localSelectedPlatforms: [],
            productFeedback: {
                platform_name: "",
                platform_url: ""
            },
            checkOthers: false,
            currentSectionIndex: null,
            nextSection: null,
            previousSection: null
        }
    },
    computed: {
        ...mapState("DemoStore", ['selectedFeatures', 'totalPlatforms', 'selectedPlatforms', 'sections', 'selectedSection'])
    },
    mounted() {
        if (!this.selectedFeatures.length) {
            this.$bvToast.toast(`Please select at least one feature to get platforms.`, {
                title: "Weavr Sense",
                variant: "danger",
                toaster: "b-toaster-bottom-center",
                autoHideDelay: 3000
            });
        }
        if (this.selectedPlatforms.length) {
            this.localSelectedPlatforms = this.selectedPlatforms;
        }
        this.getFeatureWisePlatform();
        this.currentSectionIndex = this.sections.indexOf(this.selectedSection)
        this.nextSection = this.sections[this.currentSectionIndex + 1];
        this.previousSection = this.sections[this.currentSectionIndex - 1];
    },
    methods: {
        ...mapActions("DemoStore", ['setDemoLoader', 'setSelectedSection', 'setTotalPlatforms', 'setSelectedPlatforms']),
        getFeatureWisePlatform() {
            this.setDemoLoader(true)
            const url = "/api/demo/feature_platform";
            const payload = {
                feature_ids: this.selectedFeatures.map(feature => feature.feature_id),
                region_id: this.$store.state.DemoStore.selectedRegion.id
            };

            this.$http.post(url, payload).then(res => {
                let resData = res.body.data;
                let filteredSelectedPlatforms = [];

                if (resData.length) filteredSelectedPlatforms = resData.filter(platform => platform.isSelected && platform);

                this.setTotalPlatforms(resData);
                this.setSelectedPlatforms(filteredSelectedPlatforms);
                this.setDemoLoader(false);
            }).catch(err => {
                this.setDemoLoader(false)
            })
        },
        selectPlatforms(platform) {
            platform.isSelected = !platform.isSelected
        },
        saveSelectedPlatforms() {
            let filteredPlatforms = this.totalPlatforms.filter(platform => platform.isSelected && platform);
            this.setSelectedPlatforms(filteredPlatforms);
            
            if(!filteredPlatforms.length) {
                this.$bvToast.toast(`Please select platform(s) to move forward.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                return;
            }

            this.setDemoLoader(true);
            const url = "/api/demo/save_platform";
            const payload = {
                platform_ids: filteredPlatforms.map(platform => platform.platform_id),
                region_id: this.$store.state.DemoStore.selectedRegion.id    
            }

            this.$http.post(url, payload).then(res => {
                this.setDemoLoader(false);
                this.$bvToast.toast(`Platform(s) saved successfully.`, {
                    title: "Weavr Sense",
                    variant: "success",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                this.setSelectedSection(this.nextSection);
            }).catch(err => {
                console.log("failed", err)
                this.setDemoLoader(false);
                this.$bvToast.toast(`Error in saving platform(s).`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.demo-input {
    padding: 4px 10px;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    color: var(--primary_brand);
}

.demo-input::placeholder {
    color: #919191;
    font-family: "Poppins", sans-serif;
}

.demo-input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.demo-btn {
    color: #919191;
    background-color: transparent;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    padding: 6px 12px;
    margin-right: 20px;
    margin-bottom: 12px;
}

.demo-btn.active {
    background-color: var(--primary_brand);
    border: 1px solid var(--primary_brand);
    color: white;
    font-weight: 500;
}

.demo-btn:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #EBEBEB !important;
}

.demo-btn.active:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.section-heading h4 {
    font-size: 18px;
    font-weight: 600;
}

.section-heading p {
    color: #5E5E5E;
    font-size: 14px;
    font-weight: 500;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins", sans-serif;
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.navigationButton:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

button.primarycolor {
    height: 35px;
    border: none !important;
    margin: 0;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

button.primarycolor:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>